import React, { useEffect, useState } from "react";
import { Radio, Button, Modal, Form, Input,  Select, Pagination, Switch,Tag } from 'antd';
import { BreathAPIs } from "../../../APIs/BreathAPIs";
import styles from "./styles.module.css";
import { MinusCircleOutlined, PlusCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { toast } from 'react-toastify';

function AddUserGroup({ showAddUserGroupModal, setShowAddUserGroupModal, setUserGroupData, locations,setUserGroupPagination }) {


  const [userPermissions, setUserPermissions] = useState([]);
  const [viewPermissionToggle, setViewPermissionToggle] = useState(false)
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  // const [locationSpecificPermissions, setLocationSpecificPermissions] = useState([]);
  const [customChildPermissionsCount, setCustomChildPermissionsCount] = useState([]);
  const [customChildPermissions, setCustomChildPermissions] = useState([]);
  const [form] = Form.useForm();
  const [pagination, setPagination] = useState({
    total: 0,
    current: 1,
    pageSize: 5,
    totalPages: 0
  });
  const [permissionsToggle,setPermissionsToggle] = useState('Available Permissions');
  const [isLoading,setIsLoading] = useState(false);

  // Handle page change
  const handlePageChange = (currentPage) => {
    // const {current,pageSize} = pagination;
    // console.log(current);
    // console.log(pageSize);
    fetchUserPermissions(currentPage, pagination.pageSize);
  };

  const handlePermissionIsLocationSpecificChange = (selectedPermission, checked) => {
    setUserPermissions((permissions) =>
      permissions.map((permission) =>
        permission._id === selectedPermission._id
          ? { ...permission, isLocationSpecific: checked }
          : permission
      )
    );
  
    const updatedPermissions = selectedPermissions.map((permission) =>
      permission._id === selectedPermission._id
        ? { ...permission, isLocationSpecific: checked }
        : permission
    );
  
    if (checked) {
      // Add child permission
      const finalUpdatedPermissions = [
        ...updatedPermissions,
        {permissionName: `${selectedPermission.permissionName}Locations`, permissionSelectedValue: [],showDisplay:false }
      ]
      setSelectedPermissions(finalUpdatedPermissions);

       // Update the form field
      //  form.setFieldsValue({
      //   permissions: JSON.stringify(finalUpdatedPermissions.reduce((acc, curr) => {
      //     acc[curr.permissionName] = curr.permissionSelectedValue;
      //     return acc;
      //   }, {}))
      // });

    } else {
      // Remove child permission
      const finalUpdatedPermissions = updatedPermissions.filter(
        (permission) => permission.permissionName !== `${selectedPermission.permissionName}Locations`
      );
      setSelectedPermissions(finalUpdatedPermissions);

      // Update the form field
      // form.setFieldsValue({
      //   permissions: JSON.stringify(finalUpdatedPermissions.reduce((acc, curr) => {
      //     acc[curr.permissionName] = curr.permissionSelectedValue;
      //     return acc;
      //   }, {}))
      // });
    }
  };
  const handleSelectedPermissions = (selectedPermissionName,selectedValues)=>{

    try {
      const updatedPermissions = selectedPermissions.map((permission) =>
        permission.permissionName === selectedPermissionName
          ? { ...permission, permissionSelectedValue: selectedValues }
          : permission
      )
      setSelectedPermissions(updatedPermissions);

       // Update the form field
      //  form.setFieldsValue({
      //   permissions: JSON.stringify(updatedPermissions.reduce((acc, curr) => {
      //     acc[curr.permissionName] = curr.permissionSelectedValue;
      //     return acc;
      //   }, {}))
      // });
      
    } catch (error) {
      console.error(error.message);
    }

  }
  
  const handleLocationSpecificPermissions = (selectedPermissionName, selectedLocations) => {

    try {
      const updatedPermissions = selectedPermissions.map((permission) =>
        permission.permissionName === `${selectedPermissionName}Locations`
          ? { ...permission, permissionSelectedValue: selectedLocations }
          : permission
      )
      setSelectedPermissions(updatedPermissions);

       // Update the form field
      //  form.setFieldsValue({
      //   permissions: JSON.stringify(updatedPermissions.reduce((acc, curr) => {
      //     acc[curr.permissionName] = curr.permissionSelectedValue;
      //     return acc;
      //   }, {}))
      // });
      
    } catch (error) {
      console.error(error.message);
    }


  }

  const handleCustomChildPermissionCreation = (selectedPermission)=>{

    // const isPermissionSelected = selectedPermissions.some((permission)=>permission.permissionName === selectedPermission.permissionName);

    // if(isPermissionSelected){

      setCustomChildPermissionsCount((customChildPermissionsCount)=>{

        const foundPermission = customChildPermissionsCount.some((parentPermission)=>parentPermission.permissionName === selectedPermission.permissionName)
        if (foundPermission){
            // If permission exists, update child permissions count
            return customChildPermissionsCount.map((permission)=>
              permission.permissionName === selectedPermission.permissionName?
              {...permission, count:permission.count + 1}
              :
              permission
            );
        }
        else{
          // If permission doesn't exist
          return [...customChildPermissionsCount, {permissionName:selectedPermission.permissionName,count:1}]
        }

      })
    // }
    // else{
    //   toast.error(`Please select ${selectedPermission.permissionName} before adding its custom child permissions`)
    // }

  }

  const createCustomChildPermission = (selectedPermissionId,eventData,customChildPermissionInputType)=>{
       
    try {
  
    const foundCustomChildSelectedPermission = selectedPermissions.some((permission)=>permission._id === selectedPermissionId);
    const parentPermissionName = selectedPermissionId.split('-')[0];
    // Modify child permissions after they've been added to selected permissions
    if(foundCustomChildSelectedPermission){

      const updatedPermissions = selectedPermissions.map((permission)=>{
        if(permission._id === selectedPermissionId){

          if(customChildPermissionInputType==='childPermissionName'){
              return  { ...permission,permissionName:`${eventData}`}
          }
          else{
            return { ...permission,permissionSelectedValue:eventData}   
          }

        }
        else{
          return permission
        }
      })

      // console.log('permission values before change',form.getFieldsValue('permissions'))

      // form.setFieldsValue({
      //   permissions: JSON.stringify(updatedPermissions.reduce((acc, curr) => {
      //     acc[curr.permissionName] = curr.permissionSelectedValue;
      //     return acc;
      //   }, {}))
      // })

      // console.log('permission values after change',form.getFieldsValue('permissions'))
      // setSelectedPermissions(updatedPermissions)

      setSelectedPermissions((permissions)=>{
        
        return permissions.map((permission)=>{
          if(permission._id === selectedPermissionId){
  
            if(customChildPermissionInputType==='childPermissionName'){
                return  { ...permission,permissionName:`${eventData}`}
            }
            else{
              return { ...permission,permissionSelectedValue:eventData}   
            }
  
          }
          else{
            return permission
          }
        })
        
      })
  
  
  
    }
    else{
            setCustomChildPermissions((permissions)=>{
                const permissionFound =  permissions.some((permission)=>permission._id=== selectedPermissionId );
                if(permissionFound){ 
                  // Custom child permission exists    
                  if(customChildPermissionInputType==='childPermissionName'){
                      return permissions.map((permission)=>
                        permission._id === selectedPermissionId ? { ...permission,permissionName:`${eventData}`} : permission
                      )
                  }
                  else{
                     return permissions.map((permission)=>
                        permission._id=== selectedPermissionId ? { ...permission,permissionSelectedValue:eventData} : permission
                      )
                  }
                }
                else{
                  // Permission doesn't exist, create the permission
            
                  if(customChildPermissionInputType==='childPermissionName'){
            
                    return [...permissions,{_id:selectedPermissionId,permissionName:`${eventData}`,permissionSelectedValue:''}]
                  }
                  else{
                    return [...permissions,{_id:selectedPermissionId,permissionName:'',permissionSelectedValue:eventData}]
            
                  }
                }
                
              })
  
    }
    } catch (error) {
      console.error(error.message)
    }
      
  
  }

const updateCustomChildPermissions = (selectedPermissionId)=>{
    const foundChildPermission =  customChildPermissions.find((childPermission)=>childPermission._id === selectedPermissionId)
    if(foundChildPermission){
      // Remove custom child permission from selected permissions 
      const parentPermissionName = selectedPermissionId.split('-')[0]
      const foundPermission = selectedPermissions.find((permission)=>permission._id === foundChildPermission._id)
      if(foundPermission){
        let updatedPermissions = selectedPermissions.filter((permission)=>permission._id!==foundPermission._id)
        let updatedCustomChildPermission = customChildPermissions.filter((permission)=>permission._id!==foundPermission._id)
        // updatedCustomChildPermission.forEach((permission, index) => {
        //   permission._id = `${parentPermissionName}-${index}`;
        // });
        //Update id as values for child permission are derived using map func. index values 
        let customCounter = 0;
        updatedCustomChildPermission.forEach((permission, index) => {
          if(permission._id.includes(parentPermissionName)){

            permission._id = `${parentPermissionName}-${customCounter}`;
            customCounter += 1;
          }
        });
        
        customCounter = 0;
        updatedPermissions.forEach((permission)=>{
          if( permission._id && permission._id.includes(parentPermissionName)){
            permission._id = `${parentPermissionName}-${customCounter}`;
            customCounter += 1;
          }
        })

        
        setSelectedPermissions(updatedPermissions);
        setCustomChildPermissions(updatedCustomChildPermission)
      
        // Remove child permission from display
        setCustomChildPermissionsCount((customChildPermissionsCount)=>{
         return customChildPermissionsCount.map((permission)=>
          permission.permissionName === selectedPermissionId.split('-')[0] ? {...permission, count:permission.count - 1} : permission
        )
        })
         // Update the form field
        //  form.setFieldsValue({
        //   permissions: JSON.stringify(updatedPermissions.reduce((acc, curr) => {
        //     acc[curr.permissionName] = curr.permissionSelectedValue;
        //     return acc;
        //   }, {}))
        // });
      }
     
      else{
        const permissionNameCheck = selectedPermissionId.split('-')[0];
        // Check if child permission name is unique
        if (permissionNameCheck === foundChildPermission.permissionName || foundChildPermission.permissionName === ''  || selectedPermissions.find((permission)=>permission.permissionName === `${permissionNameCheck}${foundChildPermission.permissionName}`)) {
                  toast.error(`Please enter a unique permission name `);
        }
        // Check if child permission has some value entry 
        else if(!(foundChildPermission.permissionSelectedValue.length>0)){
          toast.error(`Please enter a permission value`)
        }
        else{
          // Add the child permission to selected permissions
          const updatedPermissions = [...selectedPermissions, {_id:selectedPermissionId,permissionName:`${permissionNameCheck}${foundChildPermission.permissionName}`,showDisplay: false ,permissionSelectedValue:foundChildPermission.permissionSelectedValue}]
          setSelectedPermissions(updatedPermissions);
           // Update the form field
        //  form.setFieldsValue({
        //   permissions: JSON.stringify(updatedPermissions.reduce((acc, curr) => {
        //     acc[curr.permissionName] = curr.permissionSelectedValue;
        //     return acc;
        //   }, {}))
        // });
        }
      }

      
    }
    else{
      toast.error('Please enter child permission details')
    }
}

  async function fetchUserPermissions(page = 1, pageSize = 5) {
    try {
      let userPermissionsData = await BreathAPIs.getUserPermissionsList({ page: page, limit: pageSize })
      // console.log('UserPermissions: ',userPermissionsData.data.userPermissions);
      // console.log("userGroupResponse", userGroupResponse)
      setUserPermissions(userPermissionsData.data.response.permissions);
      setPagination({
        total: userPermissionsData.data.response.pagination.total,
        current: userPermissionsData.data.response.pagination.current,
        pageSize: userPermissionsData.data.response.pagination.pageSize,
        totalPages: userPermissionsData.data.response.pagination.totalPages
      });
    } catch (error) {
      console.log(error)
    }
  }
  
  const updatePermissions = (permission) => {
    // console.log(permission);
    // console.log("selected permissions: ", selectedPermissions);

    try {
      if (selectedPermissions.find((selectedPermission) => selectedPermission.permissionName === permission.permissionName)) {
        // Remove the parent permission and child permission if it exists as well ; No child exists without parent
        const updatedPermissions = selectedPermissions.filter(
          (selectedPermission) =>
            !selectedPermission.permissionName.includes(permission.permissionName)
        );

        setSelectedPermissions(updatedPermissions);

        //Set Location Specific to False if parent permission is removed
        setUserPermissions((permissions) =>
          permissions.map((userpermission) =>
            userpermission._id === permission._id
              ? { ...userpermission, isLocationSpecific: false }
              : userpermission
          )
        );
        
        // Remove custom child permission count if parent permission is removed 
        setCustomChildPermissionsCount((customChildPermissions)=>{
            return customChildPermissions.filter((customChildPermission)=>
              customChildPermission.permissionName!==permission.permissionName
            )
        })

        // Remove custom child permission if parent permission is removed 
        setCustomChildPermissions((customChildPermissions)=>{
          return customChildPermissions.filter((customChildPermission)=>!customChildPermission._id.includes(permission.permissionName))
        })

        // Update the form field
        // form.setFieldsValue({
        //   permissions: JSON.stringify(updatedPermissions.reduce((acc, curr) => {
        //     acc[curr.permissionName] = curr.permissionSelectedValue;
        //     return acc;
        //   }, {}))
        // });
      } else {
        // Add the permission if a value is selected
        if (permission.permissionSelectedValue || (permission.permissionSelectedValue && permission.permissionSelectedValue.length > 0)) {
          const updatedPermissions = [...selectedPermissions, permission];
          setSelectedPermissions(updatedPermissions);

          // Update the form field
          // form.setFieldsValue({
          //   permissions: JSON.stringify(updatedPermissions.reduce((acc, curr) => {
          //     acc[curr.permissionName] = curr.permissionSelectedValue;
          //     return acc;
          //   }, {}))
          // });
        } else {
          toast.error(`Select Permission Value for ${permission.permissionName}`);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function userGroupSubmit() {

    setIsLoading(true)
    form.setFieldsValue({
      permissions: JSON.stringify(selectedPermissions.reduce((acc, curr) => {
        acc[curr.permissionName] = curr.permissionSelectedValue;
        return acc;
      }, {}))
    })


    form
      .validateFields() // Validate all fields
      .then(async (values) => {
        values['createdAt'] = new Date();

        // console.log('form permissions: ',values['permissions'])

        const parsedPermissions = JSON.parse(values['permissions']);
        
        values['permissions'] = JSON.stringify(Object.keys(parsedPermissions)
          .sort() // Sort the keys alphabetically
          .reduce((acc, key) => {
            acc[key] = parsedPermissions[key]; // Rebuild the object in sorted order
            return acc;
          }, {}));
        
        // console.log('Form Submitted:', values);
        const response = await BreathAPIs.createUserGroup(values);
        // console.log('response: ',response);
        setUserGroupData(() => {
          return response.data.data.userGroups
        })
        setUserGroupPagination({
          total: response.data.data.pagination.total,
          current: response.data.data.pagination.current,
          pageSize: response.data.data.pagination.pageSize,
          totalPages: response.data.data.pagination.totalPages
          });
        setSelectedPermissions([]);
        setUserPermissions([]);
        setViewPermissionToggle(false);
        // setLocationSpecificPermissions([]);
        setCustomChildPermissionsCount([]);
        setCustomChildPermissions([]);
        form.resetFields();
        setShowAddUserGroupModal(!showAddUserGroupModal);
        toast.success(response.data.message)
        setIsLoading(false);
      })
      .catch((errorInfo) => {
        console.error('Validation Failed:', errorInfo.message ? errorInfo.message : 'All the mandatory fields of the form are not filled');
        // toast.error(response.data.message)
        setIsLoading(false);
        toast.error(errorInfo?.response?.data?.message || 'Please fill the form')
      });

    // form.resetFields();
    // setSelectedPermissions([]);
    // setUserPermissions([]);
    // setViewPermissionToggle(false);
    // setShowAddUserGroupModal(!showAddUserGroupModal);

  }

  useEffect(() => {
    fetchUserPermissions();
  }, [])

// console.log('custom child permissions: ',customChildPermissions)
// console.log('form permissions: ',form.getFieldsValue())

  return (
    <Modal
      title="Create User Group"
      open={showAddUserGroupModal}
      onOk={() => { userGroupSubmit() }}
      confirmLoading={isLoading}
      onCancel={() => {
        setShowAddUserGroupModal(!showAddUserGroupModal);
        form.resetFields();
        setSelectedPermissions([]);
        setUserPermissions([]);
        // setLocationSpecificPermissions([]);
        setCustomChildPermissionsCount([]);
        setCustomChildPermissions([]);

      }}
      okText="Submit"
    >

      <Form
        initialValues={{
          groupName: '',
          isActive: null,
          permissions: ''
        }}
        form={form}
        layout="vertical"
      >
        
        <Form.Item name="groupName" label="User Group Name" rules={[{ message: 'Please enter permission name!', required: true },]}>
          <Input
            placeholder="Enter User Group Name"
          // onChange={(e) => setUserGroupFormData((prev) => ({ ...prev, groupName: e.target.value }))}
          />
        </Form.Item>
        <Form.Item name="isActive" label="isActive" rules={[{ required: true },]}>
          <Select options={[{ value: true, label: 'True' }, { value: false, label: 'False' }]}
            placeholder="Select True / False"
          //  onChange={(e) => setUserGroupFormData((prev) => ({ ...prev, isActive: e.target.value }))}
          />
        </Form.Item>
        
        <div style={{display:'block',marginBottom:'1rem',textAlign:'center'}}>
        
          <Radio.Group block 
          options={[
                              {
                                label: 'Available Permissions',
                                value: 'Available Permissions',
                              },
                              {
                                label: 'Selected Permissions',
                                value: 'Selected Permissions',
                              },
                              
                            ]} 
              defaultValue = {permissionsToggle}
              style={{ width: '100%' }}
              onChange={(event)=>{setPermissionsToggle(event.target.value)}}
              optionType="button" 
              
              />
              
        </div>
        
        <Form.Item name="permissions" key={pagination.current}  rules={[{ required: true, message: 'Please select at least one permission!' }]}>
          <div >
            {
              permissionsToggle==='Available Permissions'?
              (
                
                userPermissions.length > 0 ?
                
                (
                  <>
                  <div className={styles['permissionView']}>
                    {
                  (userPermissions.map((permission, index) => {
                    return (
                      <>
                        <section key={index} className={styles['permissionTile']}>
                          <div style={{ width: '100%' }}>
                          <div style={{width:'auto' ,display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h6>{permission.permissionName}</h6>
                            {
                              ( selectedPermissions.some((parentPermission) => permission.permissionName === (parentPermission.permissionName))) ?
                                <Tag color="green">Permission Added</Tag>
                                :
                                null
                            }
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <div>
                                <Select
                                  // {...(permission.permissionName.includes('Locations') && { mode: "multiple" })}
                                  value={selectedPermissions.find((selectedPermission)=>selectedPermission.permissionName === permission.permissionName)?.permissionSelectedValue || permission.permissionSelectedValue}
                                  disabled={selectedPermissions.some((selectedPermission)=>selectedPermission.permissionName === permission.permissionName)}
                                  showSearch
                                  style={{ minWidth: '10em', maxWidth: '15em' }}
                                  placeholder='Select Value'
                                  // options={permission.permissionValues.map((permissionValue) => ({
                                  //   label: `${permission.permissionName.includes('Locations')
                                  //     ? locations.find((location) => location._id === permissionValue)?.locationName || permissionValue
                                  //     : permissionValue}`,
                                  //   value: `${permissionValue}`,
                                  // }))}
                                  options={permission.permissionValues.map((permissionValue) => ({
                                    label: `${!permission.permissionName.includes('Locations')
                                      ? permissionValue
                                      : locations.find((location) => location._id === permissionValue)?.locationName || permissionValue}`,
                                    value: `${permissionValue}`,
                                  }))}
                                  onChange={(selectedValues) => {
                                    // console.log('selectedValues: ',selectedValues)
                                   permission.permissionSelectedValue = selectedValues; // Use the selected values array
                                    
                                  }}
                                  filterOption={(input, option) =>
                                    option.label.toLowerCase().includes(input.toLowerCase())
                                  }
                                />
                              </div>
                              <div>
                                <Button
                                  onClick={() => { updatePermissions(permission) }}
                                  className={selectedPermissions.find((selectedPermission) => selectedPermission.permissionName === permission.permissionName) ? styles['removeButton'] : styles['addButton']}
                                  icon={selectedPermissions.find((selectedPermission) => selectedPermission.permissionName === permission.permissionName) ? <MinusCircleOutlined /> : <PlusCircleOutlined />}
                                />
                              </div>

                            </div>
                            {/* <div style={{ marginTop: '1rem' }}>
                              {'Location Specific'}
                              <Switch
                                disabled={selectedPermissions.find((selectedPermission) => selectedPermission._id === permission._id) ? false : true}
                                style={{ margin: '0rem 1rem' }}
                                // We only want the switch to be active once the parent permission has been added to selected permissions
                                checked={permission.isLocationSpecific && selectedPermissions.find((selectedPermission) => selectedPermission._id === permission._id)}
                                // checked = {permission.isLocationSpecific}
                                onChange={(checked) => { handlePermissionIsLocationSpecificChange(permission, checked) }} />
                            </div>
                          
                            <div >
                              <Button style={{ width: '100%', marginTop:'1rem' }} onClick={()=>{handleCustomChildPermissionCreation(permission)}} color="default" variant='outlined'>Create Custom Child Permissions</Button>
                            </div> */}
                          </div>

                        </section>
                        
                        {/* {
                          permission.isLocationSpecific &&
                          <section className={styles['permissionTileAdditional']}>
                            <div style={{ width: '100%' }}>
                              <h5>{`${permission.permissionName}Locations`}</h5>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div>

                                  <Select
                                    // disabled={true}
                                    mode="multiple"
                                    showSearch
                                    style={{ minWidth: '10em', maxWidth: '15em' }}
                                    placeholder='Select Locations'
                                    options={locations.map((location) => ({
                                      label: `${location.locationName}`,
                                      value: `${location._id}`,
                                    }))}
                                    onChange={(selectedValues) => {
                                      handleLocationSpecificPermissions(permission.permissionName, selectedValues);
                                    }}
                                    filterOption={(input, option) =>
                                      option.label.toLowerCase().includes(input.toLowerCase())
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </section>
                         }
                         {
                          Array.from({length: customChildPermissionsCount.find((parentPermission)=>parentPermission.permissionName===permission.permissionName)?.count || 0
                          }).map((_,index)=>{
                            return(
                            <section className={styles['permissionTileAdditional']}>
                              <div style={{width:'100%', display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                                <div>
                              <h5>Child Permission Name</h5>
                              <Input onChange={(event)=>{createCustomChildPermission(`${permission.permissionName}-${index}`,event.target.value,'childPermissionName')}} style={{width:'65%', marginTop:'0.35rem',marginBottom:'0.5rem'}} placeholder="Enter Child Permission Name"></Input>
                              <h5>Child Permission Values</h5>
                              <Input onChange={(event)=>{createCustomChildPermission(`${permission.permissionName}-${index}`,event.target.value,'childPermissionValue')}} style={{width:'65%', marginTop:'0.35rem',marginBottom:'0.5rem'}} placeholder="Enter Child Permission Value"/>
                                </div>
                                <div>
                                <Button
                                  onClick={() => { updateCustomChildPermissions(`${permission.permissionName}-${index}`)}}                    
                                  className={selectedPermissions.find((selectedPermission) => selectedPermission._id === `${permission.permissionName}-${index}`) ? styles['removeButton'] : styles['addButton']}
                                  icon={selectedPermissions.find((selectedPermission) => selectedPermission._id === `${permission.permissionName}-${index}`) ? <MinusCircleOutlined /> : <PlusCircleOutlined />}
                                />
                                </div>
                              </div>
                            </section>
                            )

                          })            

                         } */}
                      </>
                    )
                  }))}
                  </div>
                  <Pagination
                    current={pagination.current}
                    pageSize={pagination.pageSize}
                    total={pagination.total}
                    onChange={handlePageChange}
                    style={{ textAlign: "right", position: 'relative' }}
                  />
                 </>
                )
                
                
              
                  :
                  <div className={styles['permissionView']}>No permissions available</div>
              )
              :
              (
                <div className={styles['permissionView']}>
                  {
                selectedPermissions.length > 0 ? 
                ((selectedPermissions.map((permission, index) => {
                  return (
                    <>
                    {
                      (permission.showDisplay!== false)
                      &&
                      <>
                       <section key={index} className={styles['permissionTile']}>
                        <div style={{ width: '100%' }}>
                          <div style={{width:'auto' ,display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{display: 'flex', justifyContent: 'space-between',flexDirection:'column'}}>
                            <h6>{permission.permissionName}</h6>
                            <div>
 
                                <Select
                                  {...(permission.permissionName.includes('Locations') && { mode: "multiple" })}
                                  showSearch
                                  style={{ minWidth: '10em', maxWidth: '15em' }}
                                  placeholder='Select Value'
                                  value={permission.permissionSelectedValue}
                                  // options={permission.permissionValues.map((permissionValue) => ({
                                  //   label: `${permission.permissionName.includes('Locations')
                                  //     ? locations.find((location) => location._id === permissionValue)?.locationName || permissionValue
                                  //     : permissionValue}`,
                                  //   value: `${permissionValue}`,
                                  // }))}
                                  options={permission.permissionName.includes('Locations')?
                                    (locations.map((location)=>{ return {label:`${location.locationName}`,value:`${location._id}`}})):
                                    (permission.permissionValues.map((permissionValue)=>{return {label:`${permissionValue}`,value:`${permissionValue}`}}))}
                                  onChange={(selectedValues) => {
                                    // console.log('selectedValues: ',selectedValues)
                                    // permission.permissionSelectedValue = selectedValues; // Use the selected values array
                                    handleSelectedPermissions(permission.permissionName,selectedValues)
                                  }}
                                  filterOption={(input, option) =>
                                    option.label.toLowerCase().includes(input.toLowerCase())
                                  }
                                />
                            </div>
                            </div>
                            <div style={{display: 'flex',flexDirection:'column'}}>
                            {
                              ( selectedPermissions.find((parentPermission) => permission.permissionName.includes(parentPermission.permissionName) && parentPermission.permissionName.length < permission.permissionName.length)) ?
                                <Tag color="cyan">Child  Permission</Tag>
                                :
                                <Tag color="blue">Parent Permission</Tag>
                            }
                            <Tag style={{marginTop:'0.5rem'}} color="gold">{selectedPermissions.find((parentPermission) => permission.permissionName.includes(parentPermission.permissionName) && parentPermission.permissionName.length <= permission.permissionName.length)?.permissionName}</Tag>
                            </div>
                          </div>
                          <div style={{ display: 'flex', justifyContent:'space-between',alignItems:'center' , margin:'1rem 0rem' }}>
                          <div >
                            {'Location Specific'}
                            <Switch
                              disabled={selectedPermissions.find((selectedPermission) => selectedPermission._id === permission._id) ? false : true}
                              style={{ margin: '0rem 1rem' }}
                              // We only want the switch to be active once the parent permission has been added to selected permissions
                              checked={permission.isLocationSpecific && selectedPermissions.find((selectedPermission) => selectedPermission._id === permission._id)}
                              // checked = {permission.isLocationSpecific}
                              onChange={(checked) => { handlePermissionIsLocationSpecificChange(permission, checked) }} />
                          </div>
                            <div>
                              <Button
                                onClick={() => { updatePermissions(permission) }}
                                className={selectedPermissions.find((selectedPermission) => selectedPermission.permissionName === permission.permissionName) ? styles['removeButton'] : styles['addButton']}
                                icon={selectedPermissions.find((selectedPermission) => selectedPermission.permissionName === permission.permissionName) ? <MinusCircleOutlined /> : <PlusCircleOutlined />}
                              />
                            </div>

                          </div>
                         
                        
                          <div >
                            <Button style={{ width: '100%', marginTop:'1rem' }} onClick={()=>{handleCustomChildPermissionCreation(permission)}} color="default" variant='outlined'>Create Custom Child Permissions</Button>
                          </div>
                        </div>
                            {console.log('selected permissions: ',selectedPermissions)}
                      </section>
                      {
                        permission.isLocationSpecific &&
                            <section className={styles['permissionTileAdditional']}>
                              <div style={{ width: '100%' }}>
                                <div style={{ width: 'auto', display: 'flex', justifyContent: 'space-between' }}>
                                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <h6>{`${permission.permissionName}Locations`}</h6>
                                    <div >
                                      <Select
                                        // disabled={true}
                                        value={
                                          selectedPermissions.find(
                                            (selectedPermission) => selectedPermission.permissionName === `${permission.permissionName}Locations`
                                          )?.permissionSelectedValue || [] // Use an empty array as a fallback
                                        }
                                        mode="multiple"
                                        showSearch
                                        style={{ minWidth: '10em', maxWidth: '15em' }}
                                        placeholder='Select Locations'
                                        options={locations.map((location) => ({
                                          label: `${location.locationName}`,
                                          value: `${location._id}`,
                                        }))}
                                        onChange={(selectedValues) => {
                                          handleLocationSpecificPermissions(permission.permissionName, selectedValues);
                                        }}
                                        filterOption={(input, option) =>
                                          option.label.toLowerCase().includes(input.toLowerCase())
                                        }
                                      />

                                    </div>
                                  </div>
                                  <div style={{ width: 'auto', display: 'flex', flexDirection: 'column' }}>
                                    <Tag color="cyan">Child  Permission</Tag>
                                    <Tag style={{ marginTop: '0.5rem' }} color="gold">{selectedPermissions.find((parentPermission) => permission.permissionName.includes(parentPermission.permissionName) && parentPermission.permissionName.length <= permission.permissionName.length)?.permissionName}</Tag>
                                  </div>
                                </div>
                              </div>
                            </section>
                       }
                       {
                        Array.from({length: customChildPermissionsCount.find((parentPermission)=>parentPermission.permissionName===permission.permissionName)?.count || 0
                        }).map((_,index)=>{
                          return(
                          <section className={styles['permissionTileAdditional']}>
                           
                             
                              <div>
                             <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center'}} >
                              <div>
                              <h6>Child Permission Name</h6>
                              <Input onChange={(event)=>{createCustomChildPermission(`${permission.permissionName}-${index}`,event.target.value,'childPermissionName')}} style={{width:'100%', marginTop:'0.35rem',marginBottom:'0.5rem'}} placeholder="Enter Child Permission Name"
                                disabled={selectedPermissions.find((selectedPermission)=>selectedPermission._id ===`${permission.permissionName}-${index}` )?.permissionName}
                                value={selectedPermissions.some((selectedPermission)=>selectedPermission._id ===`${permission.permissionName}-${index}` )?selectedPermissions.find((selectedPermission)=>selectedPermission._id ===`${permission.permissionName}-${index}` ).permissionName : customChildPermissions.find((selectedPermission)=>selectedPermission._id ===`${permission.permissionName}-${index}` )?.permissionName }
                                
                              ></Input>
                              </div>
                              <div  style={{ display:'flex',justifyContent:'flex-end',flexDirection:'column'}}>
                                <Tag style={{top:'-1.15rem'}} color="cyan">Child Permission</Tag>
                                <Tag style={{top:'-0.65rem'}} color="gold">{permission.permissionName}</Tag>
                              </div>
                              </div>   
                            <div  style={{ display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                            <h6>Child Permission Values</h6>
                            <div>
                              <Button
                                onClick={() => { updateCustomChildPermissions(`${permission.permissionName}-${index}`)}}                    
                                className={selectedPermissions.find((selectedPermission) => selectedPermission._id === `${permission.permissionName}-${index}`) ? styles['removeButton'] : styles['addButton']}
                                icon={selectedPermissions.find((selectedPermission) => selectedPermission._id === `${permission.permissionName}-${index}`) ? <MinusCircleOutlined /> : <PlusCircleOutlined />}
                              />
                              </div>
                            </div>
                            <Input onChange={(event)=>{createCustomChildPermission(`${permission.permissionName}-${index}`,event.target.value,'childPermissionValue')}} style={{width:'47.5%', marginTop:'0.35rem',marginBottom:'0.5rem'}} placeholder="Enter Child Permission Value"
                              disabled={selectedPermissions.find((selectedPermission)=>selectedPermission._id ===`${permission.permissionName}-${index}` )?.permissionName}
                              value={selectedPermissions.some((selectedPermission)=>selectedPermission._id ===`${permission.permissionName}-${index}` )?selectedPermissions.find((selectedPermission)=>selectedPermission._id ===`${permission.permissionName}-${index}` ).permissionSelectedValue : customChildPermissions.find((selectedPermission)=>selectedPermission._id ===`${permission.permissionName}-${index}` )?.permissionSelectedValue }

                            />
                              </div>
  
                          </section>
                          )

                        })            

                       }
                      </>
                    }
                    </>
                  )
                })))
                :
                (
                  <p>No permissions selected</p>
                )
              }
                </div>
              )
              

            }

          </div>

        </Form.Item>
      </Form>

      

    </Modal>
  )
}

export default AddUserGroup